export const getScheduleErrorMessage = (ids: string[]): string =>
  `Ad's schedule can not be copied to the next Line Items: ${ids.join(
    ', '
  )}. Ad's schedule conflicts with these line items schedules. Please consider removing these line items from the list if it is needed to copy the ad's schedule.`;
